<mindbase-guided-tour />
<div class="main-shell">
  <div
    class="top_header"
    [class.top_header--tutor-counsellor]="currentPath === 'tutorCounselor'"
    [class.top_header--student-app]="currentPath === 'studentParent'">
    <div class="top_header_lft">
      <div class="logo-brand">
        <img src="assets/images/masary-logo.svg" alt="logo" />
      </div>
      <div class="header_button">
        <button type="button">AI-Enabled University &amp; Career Readiness</button>
      </div>
      <button type="button" class="toggle_btn" (click)="toggleSidenav()"><mat-icon>menu</mat-icon></button>
    </div>
    <div class="top_header_ryt">
      @if (profile?.role === userRole.STUDENT && canAccessPackageBundle) {
        <!-- Premium purchase is switched off for now; remove `disabled` to re-enable. -->
        <button type="button" class="header-upgrade-premium-btn" disabled (click)="goToPurchasePremium()">
          <svg class="header-upgrade-premium-btn__crown" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 18h18l-1.5-9-4.5 4-3-6-3 6-4.5-4L3 18z" fill="currentColor" />
            <circle cx="3" cy="7" r="1.6" fill="currentColor" />
            <circle cx="12" cy="4.5" r="1.6" fill="currentColor" />
            <circle cx="21" cy="7" r="1.6" fill="currentColor" />
          </svg>
          <span>{{ 'Premium' | translate }}</span>
        </button>
      }
      @if (profile?.role === userRole.STUDENT && (currentPath === 'studentParent' || currentPath === 'tutorCounselor')) {
        <span class="header-divider" aria-hidden="true"></span>
      }
      @if (profile && (currentPath === 'studentParent' || currentPath === 'tutorCounselor')) {
        <button
          type="button"
          class="header-notif-btn"
          matTooltip="Notifications"
          matTooltipPosition="below"
          (click)="onNotificationClick()"
          [matBadge]="notificationCount && notificationCount > 0 ? notificationCount : null"
          matBadgeColor="warn"
          matBadgeSize="small">
          <mat-icon>notifications</mat-icon>
        </button>
      }
      @if (profile && currentPath === 'studentParent' && profile.role === userRole.STUDENT && profile.gamification_level && canAccessAchievements) {
        <div
          class="header-level-badge"
          [class.header-level-badge--prestige]="profile.gamification_level >= 11"
          [routerLink]="['/dashboard/achievements']">
          <span class="header-level-badge__num">
            {{ profile.gamification_level }}
            @if (profile.gamification_level >= 11) {
              <svg class="header-level-badge__crown" viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">
                <path d="M3 18h18l-1.5-9-4.5 4-3-6-3 6-4.5-4L3 18z" />
              </svg>
            }
          </span>
          <div class="header-level-badge__info">
            <span class="header-level-badge__sublabel">{{ profile.gamification_level >= 11 ? 'Prestige' : 'Level' }}</span>
            <span class="header-level-badge__rank">{{ profile.gamification_level_name }}</span>
          </div>
        </div>
      }

      @if (profile) {
        <button type="button" class="user-pf" (click)="handleRouteNavigation()">
          <figure>
            <img
              [src]="profile.image ? profile.image : assets.userPlaceholderLogo"
              (error)="onImageError($event)"
              alt="open profile" />
          </figure>
          <div class="user_pf_rt">
            @if (profile) {
              <h2>{{ profile.name ? profile.name : profile.firstName }}</h2>
              @if (currentPath === 'tutorCounselor') {
                <span class="user-pf__role-badge">{{
                  profile.role === userRole.COUNSELOR
                    ? ('RoleCounsellor' | translate)
                    : ('RoleTutor' | translate)
                }}</span>
              } @else if (currentPath === 'studentParent') {
                <span class="user-pf__role-badge user-pf__role-badge--student">{{
                  profile.role === userRole.PARENT
                    ? ('Parent' | translate)
                    : ('Student' | translate)
                }}</span>
              }
            }
          </div>
          @if (currentPath === 'studentParent') {
            <mat-icon class="user-pf__chevron" aria-hidden="true">expand_more</mat-icon>
          }
        </button>
      }
    </div>
  </div>

  <mat-sidenav-container class="main-sidenav-container">
    <mat-sidenav
      #sidenav
      mode="side"
      class="example-sidenav"
      [ngStyle]="{ 'width.em': sidenavWidth }"
      [opened]="isSidenavCollapsed"
      (mouseenter)="onSidebarHover(true)"
      (mouseleave)="onSidebarHover(false)">
      @if (currentPath === 'tutorCounselor') {
        <mindbase-tutor-sidebar></mindbase-tutor-sidebar>
      } @else if (currentPath === 'studentParent') {
        <mindbase-sidebar></mindbase-sidebar>
      }
    </mat-sidenav>
    <div class="example-sidenav-content">
      <mindbase-breadcrumb />
      <div class="main_wrapper">
        <router-outlet />
      </div>
      <mat-menu #menu="matMenu"> </mat-menu>
    </div>
  </mat-sidenav-container>
</div>

@if ((profile?.role === userRole.STUDENT || profile?.role === userRole.TUTOR || profile?.role === userRole.COUNSELOR) && canAccessAiCounselor) {
  @if (!isAiCounselorPage && !isCopilotOpen) {
    <mindbase-chatbot-fab (fabClick)="toggleCopilot()"></mindbase-chatbot-fab>
  }
  <mindbase-copilot-panel [isOpen]="isCopilotOpen && !isAiCounselorPage" (closed)="onCopilotClosed()"></mindbase-copilot-panel>
}

<mindbase-notification-drawer [isOpen]="isNotificationDrawerOpen" (closed)="onNotificationDrawerClosed()"></mindbase-notification-drawer>

<mindbase-guide-host />
